import i18n, { Ti18nKeys } from "../../../../../../../constants/i18n";
import { TDescriptionType } from "../../../../../../../Types";
import AiGeneratedBadge from "../../../../../../../components/ai-generated-badge";
import ET3Div from "../../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../../core/et3-text";
import {
  SURFACE_BORDER,
  SURFACE_HEADER_BACKGROUND
} from "../../../../../../../core/et3-theme/surface-constants";
import DescriptionStatusImage from "./DescriptionStatusImage";
import {
  DESCRIPTION_HEADER_FONT_SIZE,
  DESCRIPTION_HEADER_GAP,
  DESCRIPTION_HEADER_HEIGHT,
  DESCRIPTION_HEADER_PADDING
} from "./descriptions-constants";

const DescriptionHeader = withLiteObserverAndTheme<{
  descriptionType: TDescriptionType;
  isGeneratedByAi: number;
  descriptionStatus: string;
  description: string;
  statusToneColor: string;
  statusBackgroundColor: string;
}>((props) => {
  const {
    theme,
    descriptionType,
    isGeneratedByAi,
    descriptionStatus,
    description,
    statusToneColor,
    statusBackgroundColor
  } = props;
  const { colors, unitX } = theme;
  const isSelfDescription = descriptionType === "self_description";
  const descriptionKey: Ti18nKeys = isSelfDescription
    ? "DESCRIPTION_ABOUT_ME"
    : "DESCRIPTION_ABOUT_MY_PARTNER";

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="space-between"
      alignItems="center"
      withShadow={false}
      width={0}
      height={DESCRIPTION_HEADER_HEIGHT}
      color={SURFACE_HEADER_BACKGROUND}
      style={{
        boxSizing: "border-box",
        width: "100%",
        paddingLeft: DESCRIPTION_HEADER_PADDING * unitX,
        paddingRight: DESCRIPTION_HEADER_PADDING * unitX,
        gap: DESCRIPTION_HEADER_GAP * unitX,
        borderBottom: SURFACE_BORDER
      }}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"MEDIUM"}
        fontSize={DESCRIPTION_HEADER_FONT_SIZE}
        text={i18n.get(descriptionKey)}
        isSpan={true}
        color={colors.all.maastrichtBlue}
        style={{ margin: 0 }}
      />
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-end"
        alignItems="center"
        withShadow={false}
        width={0}
        height={DESCRIPTION_HEADER_HEIGHT}
        color={colors.all.transparent}
        style={{
          width: "auto",
          flexShrink: 0,
          gap: DESCRIPTION_HEADER_GAP * unitX
        }}
        onClick={() => {}}
      >
        <AiGeneratedBadge
          isGeneratedByAi={isSelfDescription ? isGeneratedByAi : 0}
        />
        <DescriptionStatusImage
          description={description}
          descriptionStatus={descriptionStatus}
          toneColor={statusToneColor}
          backgroundColor={statusBackgroundColor}
        />
      </ET3Div>
    </ET3Div>
  );
});

export default DescriptionHeader;
